export const clientsPages = {
  list: () => import('./pages/ClientsPage'),
};
export { useClientGroupsQuery, useGetClientQuery, useListClientsQuery } from './api/clientsApi';
export { CLIENT_TEAM_UI_ENABLED } from './constants';
